<template>
    <kt-panel v-if="catMembersStatus === 'success'">
        <div class="accordion accordion-toggle-arrow" id="userGroup">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#addGroupForm"
                         aria-controls="addGroupForm">
                        {{ $t('label.add_group') }}
                    </div>
                </div>
                <div id="addGroupForm" class="collapse" aria-labelledby="addGroupForm" data-parent="#userGroup">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col lg="6" xs="12" md="12">
                                        <kt-form-group>
                                            <kt-form-label for="group_name">
                                                {{ $t('label.group_name') }}
                                            </kt-form-label>
                                            <kt-form-control ref="group_name"
                                                             dir="rtl"
                                                             name="group_name"
                                                             id="group_name"
                                                             v-model="query.group_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="6" xs="12" md="12">
                                        <kt-form-group>
                                            <kt-form-label>
                                                {{ $t('label.user') }}
                                            </kt-form-label>
                                            <select
                                                class="form-control kt-selectpicker"
                                                id="user"
                                                v-model="query.user_id"
                                                name="user"
                                                multiple
                                            >
                                                <option
                                                    v-bind:key="index"
                                                    v-for="(user, index) in categorizedUsers"
                                                    v-bind:value="user.id"
                                                >
                                                    {{ user.full_name }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                    <kt-col xs="12" sm="6" md="12">
                                        <kt-button type="submit"
                                                   id="submit_btn"
                                                   variant="success"
                                                   class="btn btn-wide">
                                            {{ $t('btn.submit') }}
                                        </kt-button>
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import {mapGetters} from "vuex";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            query: {
                user_id: []
            },
            cat_id: this.$route.params.cat_id
        }
    },
    methods: {
        afterDispatch() {
            setTimeout(function () {
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 2000)
        },
    },
    computed: {
        ...mapGetters('user', [
            'catMembersStatus', 'categorizedUsers'
        ])
    },
    mounted() {
        if (this.catMembersStatus !== 'success') {
            this.$store.dispatch('user/fetchCategoryMembers', this.cat_id).finally(() => {
                this.afterDispatch()
            })
        } else {
            this.afterDispatch()
        }
    },
}
</script>